import Login from "../../Components/Login_Section/Login";

const LoginPage = () => {
  return (
      <Login />
  );
};

export default LoginPage;
